import { IconButton } from '@mui/material'
import { SearchIcon } from '$common/icons'

interface Props {
  onClick: () => any
  backgroundColor?: string
}

// TODO: check to replace this component in appbars
export function SearchButton({ onClick, backgroundColor }: Props) {
  return (
    <IconButton
      sx={{ padding: 1, color: backgroundColor ? 'neutral000' : 'neutral700' }}
      onClick={onClick}
    >
      <SearchIcon />
    </IconButton>
  )
}
